import React, { useState } from "react";
import { Layout } from "antd";
import { useQuery, useLazyQuery } from "@apollo/client";
import { Accounts_Query, Role_Account_Query, GET_USERS_ASSIGNED_TO_ACCOUNT } from "../../services/userAPI";
import "../Dashboard/Home.css";
import { useNavigate } from "react-router-dom";
import Editicon from "../../Images/Edit.png";
import SearchableDropdown from "../../reusableField/searchableDropdownField";
import { Input, Spin, message } from "antd";
import "antd/dist/reset.css";
import { SearchOutlined } from "@ant-design/icons";

const { Content } = Layout;

const ClanCrewHome = () => {
    const navigate = useNavigate();
    const [selectedRoles, setSelectedRoles] = useState({});
    const [selectedValues, setSelectedValues] = useState({});
    const [loadingRoles, setLoadingRoles] = useState({});
    const [imageError, setImageError] = useState({});
    const [searchQuery, setSearchQuery] = useState("");
    const { loading: accountsLoading, error: accountsError, data: accountsData } = useQuery(Accounts_Query);

    const [fetchRoles] = useLazyQuery(Role_Account_Query, {
        fetchPolicy: 'network-only',
        onCompleted: (data, context) => {
            // Try to get accountId from multiple sources
            const roles = data?.getAllJobrole || [];
            let accountId = roles[0]?.account?.id;

            // If empty array, try to get from context
            if (!accountId && context?.variables) {
                accountId = context.variables.accountId;
            }

            console.log("Roles fetched:", { accountId, rolesCount: roles.length, data });

            if (accountId) {
                setSelectedRoles((prevRoles) => ({
                    ...prevRoles,
                    [accountId]: roles,
                }));
                setLoadingRoles((prev) => ({
                    ...prev,
                    [accountId]: false,
                }));
            }
        },
        onError: (error, context) => {
            console.error("Error fetching roles:", error);
            const accountId = context?.variables?.accountId || error.extraInfo?.variables?.accountId;
            if (accountId) {
                setSelectedRoles((prevRoles) => ({
                    ...prevRoles,
                    [accountId]: [],
                }));
                setLoadingRoles((prev) => ({
                    ...prev,
                    [accountId]: false,
                }));
            }
        },
    });

    const [fetchAssignedUsers] = useLazyQuery(GET_USERS_ASSIGNED_TO_ACCOUNT);

    const handleImageError = (userId) => {
        setImageError((prev) => ({
            ...prev,
            [userId]: true,
        }));
    };

    const handleAccountChange = (accountId) => {
        if (!selectedRoles.hasOwnProperty(accountId)) {
            console.log("Fetching roles for accountId:", accountId);
            setLoadingRoles((prev) => ({
                ...prev,
                [accountId]: true,
            }));

            fetchRoles({
                variables: { accountId: parseInt(accountId) },
            }).then((result) => {
                // Fallback: if onCompleted didn't handle it
                const roles = result?.data?.getAllJobrole || [];
                console.log("Fetch completed with roles:", roles.length);

                if (roles.length === 0 && !selectedRoles.hasOwnProperty(accountId)) {
                    setSelectedRoles((prevRoles) => ({
                        ...prevRoles,
                        [accountId]: [],
                    }));
                    setLoadingRoles((prev) => ({
                        ...prev,
                        [accountId]: false,
                    }));
                }
            }).catch((error) => {
                console.error("Fetch error:", error);
                setLoadingRoles((prev) => ({
                    ...prev,
                    [accountId]: false,
                }));
            });
        }
    };

    const handleRoleChange = (value, accountId) => {
        setSelectedValues((prev) => ({
            ...prev,
            [accountId]: value,
        }));
    };

    const handleViewRole = (accountId) => {
        const selectedRoleId = selectedValues[accountId];
        if (selectedRoleId) {
            const selectedRoleData = selectedRoles[accountId]?.find((role) => role.id === selectedRoleId);
            if (selectedRoleData) {
                navigate("/clan-crew-user-management", {
                    state: {
                        roleId: selectedRoleId,
                        dartsNeeded: selectedRoleData.dartsNeeded,
                        clanNeeded: selectedRoleData.clanNeeded,
                        syncNeeded: selectedRoleData.syncNeeded,
                        lenseNeeded: selectedRoleData.lenseNeeded || false,
                        emailLogin: selectedRoleData.emailLogin,
                        inputEditDays: selectedRoleData.inputEditDays,
                        mandatoryTimeDistribution: selectedRoleData.mandatoryTimeDistribution,
                        numberLogin: selectedRoleData.numberLogin,
                        name: selectedRoleData.name,
                        pocEmail: selectedRoleData.pocEmail || "",
                        pocName: selectedRoleData.pocName || "",
                        pocNumber: selectedRoleData.pocContactNumber || "",
                        targetEditDays: selectedRoleData.targetEditDays,
                        dartsFormNeeded: selectedRoleData.dartsFormNeeded,
                        accountId: selectedRoleData.account.id,
                        accountName: selectedRoleData.account?.name || "unknown",
                    },
                });
            }
        } else {
            message.warning("Please select a role first.");
        }
    };
    
    if (accountsLoading) {
        return (
            <div className="loading-container">
                <div className="spinner"></div>
            </div>
        );
    }

    if (accountsError) return <div>Error: {accountsError.message}</div>;

    const filteredAccounts = accountsData?.allUserAccount
        ?.filter((user) => user.name.toLowerCase().includes(searchQuery.toLowerCase()))
        ?.reverse();

    return (
        <Content>
            <div className="home-content">
                <div style={{ display: "flex", gap: "20px" }}>
                    <Input
                        type="text"
                        className="searchinput"
                        placeholder="Search client..."
                        value={searchQuery}
                        prefix={<SearchOutlined style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)" }} />}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <button
                        onClick={() => navigate("/create")}
                        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                    >
                    </button>
                </div>

                {filteredAccounts?.length === 0 && searchQuery && (
                    <div className="no-accounts-found">No accounts found</div>
                )}

                <div
                    className="homeCardsBackgroundColor"
                    style={{ backgroundColor: "white", padding: "20px", borderRadius: "10px", marginTop: "20px" }}
                >
                    <div className="cards-container">
                        {filteredAccounts?.map((user) => {
                            const isRoleSelected = Boolean(selectedValues[user.id]);
                            const hasNoRoles = user.numberOfRoles === 0 || selectedRoles[user.id]?.length === 0;

                            return (
                                <div key={user.id} className="card">
                                    <div className="card-header">
                                        {imageError[user.id] || !user.mainLogoUrl ? (
                                            <div className="placeholderImage">
                                                <span className="placeholder-text">No Image</span>
                                            </div>
                                        ) : (
                                            <img
                                                src={user.mainLogoUrl}
                                                alt={user.name}
                                                className="card-image"
                                                onError={() => handleImageError(user.id)}
                                            />
                                        )}
                                        {/* <img
                                            src={Editicon}
                                            alt="Edit"
                                            className="edit-icon"
                                            onClick={() => handleEdit(user.id, user)}
                                        /> */}
                                    </div>
                                    <h3 className="card-title">{user.name}</h3>

                                    <div className="card-actions">
                                        <SearchableDropdown
                                            options={selectedRoles[user.id] || []}
                                            label="name"
                                            id="id"
                                            selectedVal={selectedValues[user.id]}
                                            handleChange={(value) => handleRoleChange(value, user.id)}
                                            placeholder={
                                                hasNoRoles && !loadingRoles[user.id]
                                                    ? "No roles found"
                                                    : loadingRoles[user.id]
                                                        ? "Loading roles..."
                                                        : "Select Role"
                                            }
                                            onFocus={() => handleAccountChange(user.id)}
                                            disabled={false}
                                            loading={loadingRoles[user.id]}
                                            notFoundContent={
                                                hasNoRoles && !loadingRoles[user.id] ? "No roles found" : loadingRoles[user.id] ? <Spin size="small" /> : null
                                            }
                                        />
                                        <button
                                            className="view-role-button"
                                            onClick={() => handleViewRole(user.id)}
                                            disabled={!selectedValues[user.id] || hasNoRoles}
                                            style={{
                                                backgroundColor: selectedValues[user.id]
                                                    ? "#AD0101"
                                                    : hasNoRoles
                                                        ? "#dcdcdc"
                                                        : "#FAC9CA",
                                                cursor: selectedValues[user.id] ? "pointer" : "not-allowed",
                                            }}
                                        >
                                            View Role
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </Content>
    );
};

export default ClanCrewHome;